interface Article {
  Sku: string
  Title: string
  TitleLong: string
}

interface Summary {
  Price: number
}

interface PricehelperResponseData {
  articles: Article[]
  summary: Summary
}

export const PRODUCT_VIEW_SCRIPT_ID = 'productView'

const generateGtmScripts = (
  PricehelperResponseData: PricehelperResponseData | undefined,
  articleErpItemNumber: string,
  category: string,
  subCategory: string,
  weeksUntilDelivery: string,
  title: string,
  titleLong: string
) => {
  if (!PricehelperResponseData) return

  // 'egen tillverkning' hårdkodat även i skbv-frontend
  return `
    dataLayer.push({ 
      'ecommerce' : { 
        'detail' : { 
          'products' : [{ 
            'id' : '${articleErpItemNumber}', 
            'name' : '${`${title} - ${titleLong}`.replace(/'/g, "\\'")}', 
            'category' : '${category}', 
            'subcategory' : '${subCategory}',
            'brand' : 'egen tillverkning',
            'price' : ${PricehelperResponseData.summary.Price}, 
            'deliverytime' : ${weeksUntilDelivery}
          }] 
          } 
        }, 
        'event' : 'productView' 
      });
    `
}

export const generateGtmScriptNode = (
  PricehelperResponseData: PricehelperResponseData | undefined,
  articleErpItemNumber: string,
  category: string,
  subCategory: string,
  weeksUntilDelivery: string,
  title: string,
  titleLong: string
): HTMLElement | null => {
  const scriptContent = generateGtmScripts(
    PricehelperResponseData,
    articleErpItemNumber,
    category,
    subCategory,
    weeksUntilDelivery,
    title,
    titleLong
  )

  if (!scriptContent) return null

  const script = document.createElement('script')
  script.id = PRODUCT_VIEW_SCRIPT_ID
  script.textContent = scriptContent.trim()

  return script as HTMLElement
}
